import React, { useState } from "react";
import Input from "../../../../widget/common/form/Input";
import { LoginContextImport } from "../../../../provider/onboarding/login/LoginContextProvider";
import PhoneNumber from "../../../../widget/common/form/PhoneNumber";

export const LoginEmailTextField = () => {
  const {
    tabName,
    credential,
    handleOnChange,
    credentialErrors,
    credentialValidate,
    handleClickLogin,
  } = LoginContextImport();
  return (
    <Input
      type="email"
      name="email"
      handleOnChange={handleOnChange}
      value={credential.email}
      placeHolder="email"
      validate={tabName === "email" ? true : false}
      className="text-center"
      error={
        tabName === "email"
          ? !credentialValidate
            ? credentialErrors.email
            : false
          : false
      }
      handleEnter={handleClickLogin}
    />
  );
};

export const LoginPasswordTextField = () => {
  const {
    credential,
    handleOnChange,
    credentialErrors,
    credentialValidate,
    handleClickLogin,
  } = LoginContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };

  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="password"
      handleOnChange={handleOnChange}
      value={credential.password}
      placeHolder="password"
      prefixType="text"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      validate={true}
      className="text-center"
      error={!credentialValidate ? credentialErrors.password : false}
      handleEnter={handleClickLogin}
    />
  );
};

export const LoginPhoneTextField = () => {
  const {
    tabName,
    credential,
    handleOnChange,
    credentialErrors,
    credentialValidate,
    handleClickLogin,
    applyCountryCode,
  } = LoginContextImport();

  return (
    <PhoneNumber
      name="phone_number"
      handleOnChange={handleOnChange}
      value={credential.phoneField}
      code={credential.phoneCodeField}
      validate={tabName === "phone" ? true : false}
      error={
        tabName === "phone"
          ? !credentialValidate
            ? credentialErrors.phoneField
            : false
          : false
      }
      handleEnter={handleClickLogin}
      callback={applyCountryCode}
    />
  );
};
